import styled from 'styled-components'

import { Body, BodyProps } from '@nx/fire/typography'

export const BreadcrumbsContainer = styled(Body)<BodyProps>`
  display: block;
  margin-bottom: 25px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  ${({ theme }) => theme.fontStyles.sourceSans.medium}
`
